import type { ComponentProps } from 'react';
import React, { useId } from 'react';
import type { Nullable } from 'corgi-types';

import type { Card } from './Card';
import { CardCarouselLayout } from './CardCarouselLayout';
import { CardGridLayout } from './CardGridLayout';

interface CardGridProps {
  title: Nullable<string>;
  isLayoutCarousel: boolean;
  items: Array<Omit<ComponentProps<typeof Card>, 'index'>>;
}

const CardGrid = ({ items, title, isLayoutCarousel }: CardGridProps) => {
  const titleId = useId();
  const filteredItems = items.filter(item => !!item.href);

  if (isLayoutCarousel) {
    return <CardCarouselLayout title={title} titleId={titleId} items={filteredItems} />;
  }

  return <CardGridLayout title={title} titleId={titleId} items={filteredItems} />;
};

export default CardGrid;
